import StoreLocatorPage from '../pages/StoreLocatorPage';

const StoreLocatorSlice = props => {
  return <StoreLocatorPage />;
};

export default StoreLocatorSlice;
